<template>
  <div>
    <spinner v-if="loading" />
    <div v-else>
      <div v-if="error" class="text-center">
        <span class="primary-color form-title"> Your invite link has expired </span>
      </div>
      <form v-else v-scroll-to-error @submit.prevent="submitForm">
        <v-layout justify-center align-center>
          <v-flex xs12 sm10 md8 lg6>
            <v-layout wrap>
              <v-flex class="ml-12 mt-12 mb-50" xs12>
                <span class="primary-color form-title">Sign up</span>
              </v-flex>
              <v-flex xs12>
                <invite-form :vs="$v" :initial-values="form" @values="form = $event" />
              </v-flex>
              <v-flex xs12>
                <main-button
                  text="Create account"
                  depressed
                  @click="submitForm($refs['form'].form, $refs['form'].$refs['form'])"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </form>
    </div>
  </div>
</template>

<script>
import InviteForm from './invite-form.vue'
import {  acceptInvite } from './../../http'
import { submitGuard } from './../../utils'
import { minLength, required } from 'vuelidate/lib/validators'
import Spinner from './../shared/spinner'

export default {
  components: { InviteForm, Spinner },
  props: {
    inviteToken: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      error: null,
      loading: true,
      form: {},
    }
  },
  validations() {
    return {
      form: {
        firstName: { required },
        lastName: { required },
        password: { required, minLength: minLength(5) },
      },
    }
  },
  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        // LOGOUT
        const token = await acceptInvite(this.form, this.inviteToken)
        await this.$apollo.provider.defaultClient.resetStore()
        this.goTo(this.routes.organizer.events)
      })
    },
  },
}
</script>

<style scoped>
.background {
  height: 100%;
  background: #01579b;
}
</style>
